module.exports = {
	"ask": "Demander",
	"asking": "Demandé",
	"auction": {
		"notJoinedAny": "Vous n'avez rejoint aucun encan!"
	},
	"auctionProgress": {
		"lotsCancelled": {
			"long": "Lots annulés",
			"short": "Annulés"
		},
		"lotsSkipped": {
			"long": "Lots sautés",
			"short": "Sautés"
		},
		"lotsSold": {
			"long": "Lots vendus",
			"short": "Vendus"
		},
		"progressBarMessage": "Completé <doneLotsCount /> de <totalLotsCount /> $t(lot) (<doneLotsPercentage />)"
	},
	"auctionStatus": {
		"cancelled": "L'encan a été annulé.",
		"over": "L'encan est terminé.",
		"paused": "L'encan est en pause.",
		"waiting": "L'encan n'a pas encore débuté."
	},
	"bid": "Enchérir",
	"bidCount": "enchère",
	"bidCount_plural": "enchères",
	"bidLimitExceededShort": "dépasse limite",
	"bidStatus": {
		"cancelled": "Annulé",
		"closed": "Fermé",
		"closing": "Fermeture",
		"notStarted": "En attente",
		"ongoing": "En cours",
		"sold": "Vendu"
	},
	"bidStatusLabel": "Statut du lot",
	"bidType": {
		"bid": "enchère en ligne",
		"floorBid": "enchère sur place"
	},
	"bidTypeDemonstrate": {
		"bid": "une $t(widget-common::bidType.bid)",
		"floorBid": "une $t(widget-common::bidType.floorBid)"
	},
	"buyerType": {
		"onsite": "un acheteur sur place",
		"online": "un acheteur en ligne"
	},
	"by": "par",
	"cancel": "Annuler",
	"closingProgress": {
		"once": "Un",
		"twice": "Deux"
	},
	"connection": {
		"attemptMessage": "Ceci est la tentative __attempt__ de __retries__.",
		"awaiting": "Attente de la connexion.",
		"connected": "Connexion réussie!",
		"connecting": "Connexion en cours",
		"loadingMessage": "Chargement des données de l'encan",
		"lost": "Connexion au serveur perdue.",
		"reconnected": "Reconnexion réussie!",
		"reconnectedMessage": "__timeTaken__ secondes ont été nécessaires pour la reconnexion.",
		"reconnecting": "Reconnexion au serveur",
		"reconnectingMessage": "Reconnexion dans __timeNextReconnection__ secondes.",
		"unknownError": "Erreur de connexion inconnue."
	},
	"eventConsole": {
		"error": {
			"accessDenied": "Vous ne possédez pas les privilèges nécessaires pour effectuer cette action.",
			"alreadyLeading": "Vous possédez déjà l'enchère gagnante pour ce lot, vous ne pouvez pas effectuer une nouvelle enchère.",
			"bidInvalid": "Vous avez effectué une enchère invalide, veuillez réessayer!",
			"bidLimitExceeded": "Vous avez dépassé votre enchère maximale de __limit__ pour un même lot.",
			"bidTooLow": "L'enchère que vous avez effectuée est trop basse, veuillez réessayer!",
			"purchaseLimitExceeded": "Vous avez dépassé votre limite d'achats de __limit__ pour un même encan."
		},
		"event": {
			"administratorMessage": "Message de l'administrateur",
			"auctionCancelled": "L'encan a été annulé. Tous les lots qui n'ont pas été vendus ont également été annulés.",
			"auctionLoaded": "L'encan a été chargé, il devrait donc débuter sous peu!",
			"auctionOver": "L'encan est terminé. Merci d'avoir participé!",
			"auctionPaused": "L'encan a été mis en pause.",
			"auctionResumed": "L'encan n'est plus en pause!",
			"auctionStarted": "L'encan est maintenant en cours!",
			"bidMade": "__bidType__ de <bidAmount /> a été effectuée.",
			"bidUndone": "L'enchère de <bidAmount /> a été annulée.",
			"lotCancelled": "Le lot a été annulé.",
			"lotChanged": "Chargement du lot no. <lotRank />: <lotName />.",
			"lotClosed": "Les enchères sont maintenant fermées pour ce lot.",
			"lotClosing": "Les enchères ferment pour ce lot, dépêchez-vous!",
			"lotOpened": "Les enchères sont maintenant ouvertes pour ce lot!",
			"lotPrebidded": "Il y a eu une pré-offre de <bidAmount />.",
			"lotPrebidded_plural": "Il y a eu <preBidCount /> pré-offres et l'enchère qui mène est de <bidAmount />.",
			"lotReopened": "Les enchères sont maintenant réouvertes pour ce lot!",
			"lotSkippedOne": "Lot no. <lotRank /> sauté.",
			"lotSkippedTwo": "Lots no. <lotOneRank /> et no. <lotTwoRank /> sautés.",
			"lotSkippedMany": "Lots no. <lotStartRank /> à no. <lotEndRank /> sautés.",
			"lotSold": "Le lot a été vendu pour <amount /> à <winner />."
		}
	},
	"leadingBid": "Enchère gagnante",
	"liveBidCount": "enchère temps réel",
	"liveBidCount_plural": "enchères temps réel",
	"lot": "lot",
	"lot_plural": "lots",
	"lotCatalog": {
		"autoScrollButton": {
			"long": "Automatiquement défiler au lot actuel quand celui-ci change",
			"short": "Défiler sur changement"
		},
		"countdownTooltip": "Dans <lotCount /> $t(lot)",
		"heading": "Lot no. __lotRank__",
		"lotStatus": {
			"cancelled": "Annulé",
			"current": "Actuel",
			"skipped": "Sauté",
			"sold": "Vendu",
			"upcoming": "À venir"
		}
	},
	"lotMessages": {
		"cancelled": "Le lot a été annulé.",
		"sold": "Le lot a été vendu."
	},
	"lotRank": "Lot no.",
	"module": {
		"auction": "Encan",
		"catalog": "Catalogue",
		"events": "Événements",
		"increments": "Incréments",
		"information": "Information",
		"lots": "Lots",
		"progress": "Progrès",
		"videoStream": "Fil vidéo"
	},
	"noBid": "Aucune enchère",
	"noDescription": "Sans description.",
	"of": "de",
	"preBidCount": "pré-offre",
	"preBidCount_plural": "pré-offres",
	"previouslySkipped": "Précédemment sauté",
	"quickFilter": "Filtre rapide",
	"soldFor": "Vendu pour",
	"to": "à",
	"underApproval": "Sous approbation",
	"unknown": "Inconnu",
	"unknownError": "Une erreur inconnue est survenue.",
	"userMessages": {
		"leadingBidder": "Vous possédez déjà l'enchère gagnante sur ce lot.",
		"viewOnly": "Vous êtes en mode 'visualisation seulement'. Vous ne pouvez pas effectuer des enchères dans ce mode.",
		"wonLot": "Vous avez remporté ce lot!",
		"wonSpecificLot": "Vous avez remporté le lot no. __lotRank__!"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/widget-common.json5
// module id = 2016
// module chunks = 6